import { useSelector } from "react-redux";
import { DashboardLayout } from "../components/Dashboard";
import { businessInterface } from "../interfaces/businessInterface";
import { stringMin } from "../core/function/function-generic";

interface Props {
    onSearchGen: string;
}

export const Profile = ({onSearchGen}: Props) => {
    document.body.style.background="#FFF";
    const state = useSelector((state:{business :businessInterface})=>state.business);
    
    return (
        <>
            <DashboardLayout pageTitle="Profile" onSearchGen={onSearchGen}>
                <div className='w-full ml-8'>
                    <p className="mb-20 text-17-500">
                        Please <a href="mailto:hola@alfredpay.io?Subject=Need%20help%20with%20CMS" className="header-user underline dark:text-blue-500"> contact us </a> 
                        to update this information.</p>
                    <div className="grid grid-cols-2 gap-10 w-1/2">
                        <div className="text-17-500">Name</div>
                        <div className="text-17-500-000">{state.name}</div>
                        <div className="text-17-500">role</div>
                        <div className="text-17-500-000">{stringMin(state.role)}</div>
                        <div className="text-17-500">email</div>
                        <div className="text-17-500-000">{state.email}</div>
                        <div className="text-17-500">Password</div>
                        <div className="text-17-500-000">*********</div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 w-1/2">
                        <div className="text-17-500 header-user">Change</div>
                        <div className="text-17-500-000 ml-4">12/08/2023</div>
                    </div>
                </div>
            </DashboardLayout>
        </>
    )
}